<template>
	<v-card>
    <v-snackbar
        v-model="snackbar.status"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        elevation="3"
    >
      <v-alert
          dense
          outlined
          border="left"
          prominent
          type="warning"
          color="white"
          class="mb-0 flex-grow-1"
      >
        <v-row align="center" no-gutters>

          <v-col class="text-body-2 font-weight-bold">
            {{ snackbar.text }}
          </v-col>

          <v-col cols="auto">
            <v-btn
                text
                small
                color="white"
                @click="snackbar.status = false"
            >
              Fechar
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-snackbar>
		<v-dialog v-model="dialogErro.status" persistent>
			<CardDialog :dialog="dialogErro" />
		</v-dialog>
		<v-dialog v-model="produtoDialog" max-width="1080" max-height="1200">
			<v-card height="auto">
				<v-card-title class="primary--text pa-2 font-weight-bold">
					{{ dadosDialog.produto }}
				</v-card-title>
				<v-divider></v-divider>
				<v-img :src="dadosDialog.imagem" max-height="350" contain></v-img>
				<v-divider></v-divider>
				<v-card-subtitle class="text-body-1 pa-1">
					<p class="pa-1 ma-0"> <strong>Descrição:</strong> {{ dadosDialog.descricao }}</p>
				</v-card-subtitle>

				<v-card-text class="pa-1">
					<div class="font-weight-bold text-body-1 pa-1" v-if="dadosDialog.potencia > 0">
						<p style="color: #C62828;" class="ma-0">Potência: {{ dadosDialog.potencia }}kWp</p>
						<p class="ma-0">QTD Média de Painéis: {{ calculoProduto(dadosDialog, 'Q') }}</p>
						<p class="ma-0" style="color: #43A047;">Preço médio: {{ calculoProduto(dadosDialog, 'P') |
							formataDinheiro }}</p>
					</div>
					<div class="font-weight-bold text-body-1 pa-1" v-else>
						<p style="color: #C62828;">Potência: {{ dadosDialog.watts }}W</p>
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn block color="primary" @click="produtoDialog = false">Fechar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-progress-linear indeterminate absolute :active="carregando" />
		<v-divider />
		<v-card-text>
			<v-alert text color="primary" icon="mdi-information" class="ma-0 pt-5 pb-0">
				<p style="font-size: 0.8em">
					<strong>Este recurso tem o objetivo de auxiliar a escolha do melhor equipamento para o cliente. </strong>
					<strong>Observação: Os geradores tem sua capacidade de geração de acordo com incidência de
						irradiação solar e a correta instalação. Os dados de geração estão baseados no mapa de radiação
						global horizontal média anual do Brasil.
					</strong><br />
					<strong style="color: #E65100;">Atenção: Simulações com valor de consumo superior a 2.000 kWh devem ser encaminhadas para análise técnica. Consulte o engenheiro solar para obter
						a melhor orientação quanto ao dimensionamento e viabilidade do sistema.</strong>
				</p>
			</v-alert>
		</v-card-text>
		<v-progress-linear indeterminate absolute :active="carregando" />
		<v-divider />
		<v-card-text>
			<v-card flat dark color="primary" class="mb-3">
				<v-card-text>
					<!-- Linha 1-->
					<v-row>
						<v-col class="mb-n6 px-1" cols="12">
							<label style="color: white;" class="font-weight-bold">Cliente</label>
							<v-autocomplete no-filter v-model="clienteSelecionado.idclifor" outlined dense
								:search-input.sync="search" :items="items" :loading="carregando2" item-text="idenome"
								item-value="idcliente" @change="refreshNovoDado('CL')"></v-autocomplete>
						</v-col>
						<!-- <v-col class="mb-n6 px-1" cols="12" sm="6" md="2">
							<label style="color: white;" class="font-weight-bold">UF</label>
							<v-autocomplete v-model="dadosCalculo.uf" outlined dense :items="estados"
								:disabled="carregando" item-text="uf" item-value="id"></v-autocomplete>
						</v-col> -->
						<v-col class="mb-n6 px-1 pb-0 mt-0 pt-0" cols="12">
							<label style="color: white;" class="font-weight-bold">Cidade</label>
							<v-autocomplete v-model="dadosCalculo.cidade" outlined dense :items="cidades"
								@change="refreshNovoDado('C')" :disabled="carregando" item-text="cidade"
								item-value="id"></v-autocomplete>
							<!-- <v-autocomplete no-filter v-model="dadosCalculo.cidade" outlined dense
								:search-input.sync="searchCidade" :items="itemsCidades" :loading="carregando3"
								item-text="cidade" item-value="cidade"></v-autocomplete> -->
						</v-col>

					</v-row>

					<!-- Linha 2 -->
					<v-row>
						<v-col class="mb-n6 px-1 pb-0" cols="12" sm="6" md="6">
							<label style="color: white;" class="font-weight-bold">Consumo Médio Mensal (kWh/mês)</label>
							<v-text-field :disabled="carregando" outlined dense type="number"
								@change="refreshNovoDado('CM')" v-model.number="dadosCalculo.consumoMedio" />
						</v-col>
						<v-col class="mb-n6 px-1 mb-mobile-0" cols="12" sm="12" md="6">
							<label style="color: white;" class="font-weight-bold">Valor kWh cidade (R$)</label>
							<v-text-field :disabled="carregando" outlined dense type="number"
								@change="refreshNovoDado('V')" v-model.number="dadosCalculo.valorkWCidade" />
						</v-col>
					</v-row>

					<!-- Linha 3 -->
					<v-row>
						<v-col cols="12" sm="12" md="6" class="pa-2">
							<v-btn block dark color="#C62828" @click="limpar()">
								Limpar
							</v-btn>
						</v-col>
						<v-col cols="12" sm="12" md="6" class="pa-2">
							<v-btn block light color="#FFCA28" @click="calculos(); resultadosVisiveis = true;"
								:disabled="(!this.dadosCalculo.consumoMedio
									&& !this.dadosCalculo.valorkWCidade) || (!this.dadosCalculo.cidade) || (this.dadosCalculo.valorkWCidade === 0)">
								<v-icon class="pr-2">mdi-solar-power-variant-outline</v-icon> Calcular
							</v-btn>
						</v-col>

					</v-row>

					<!-- Linha x -->
					<!-- <v-row>
						<v-col class="mb-n6 px-1 pa-1" cols="12">
							<label style="color: white;" class="font-weight-bold">Tipo de Telhado</label>
							<v-autocomplete v-model="dadosCalculo.tipoTelhado" outlined dense :items="telhados"
								:disabled="carregando" item-text="telhado" item-value="id"></v-autocomplete>
						</v-col>

					</v-row> -->


					<!-- Linha 4 -->
					<v-fade-transition mode="out-in">
						<v-row v-show="resultadosVisiveis">

							<v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="3">
								<label style="color: white;" class="font-weight-bold">Incidencia Solar</label>
								<v-text-field v-model="dadosCalculo.incidenciaSolar" readonly outlined dense type="text"
									suffix="(Kwh/M²)" background-color="#B1E8F7" color="#023449"
									class="campoPersonalizado" style="color: #023449; font-weight: 700;" />
							</v-col>
							<v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="3">
								<label style="color: white;" class="font-weight-bold">Potência necessária do gerador
									solar</label>
								<v-text-field v-model="dadosCalculo.tamGerador" readonly outlined dense type="text"
									suffix="kWp" background-color="#B1E8F7" color="#023449" class="campoPersonalizado"
									style="color: #023449; font-weight: 700;" />
							</v-col>
							<v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="3">
								<label style="color: white;" class="font-weight-bold">QTD média de paineis</label>
								<v-text-field v-model="dadosCalculo.qtdPlacas" readonly outlined dense type="text"
									background-color="#B1E8F7" color="#023449" class="campoPersonalizado"
									style="color: #023449; font-weight: 700;" />
							</v-col>
							<v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="3">
								<label style="color: white;" class="font-weight-bold">Preço médio estimado do KIT
								</label>
								<v-text-field v-model="dadosCalculo.valorEstimadoKit" readonly outlined dense
									type="text" background-color="#B1E8F7" color="#023449" class="campoPersonalizado"
									style="color: #023449; font-weight: 700;" />
							</v-col>

						</v-row>
					</v-fade-transition>


					<!-- Linha 5 -->
					<v-fade-transition mode="out-in">
						<v-row v-show="resultadosVisiveis">
							<!-- <v-col class="mb-n6 px-1 pa-1" cols="12" sm="6">
								<label style="color: white;" class="font-weight-bold">Sustentabilidade</label>
								<v-text-field v-model="dadosCalculo.sustentabilidade" readonly outlined dense
									type="text" suffix="Kg CO² Ano" background-color="#2E7D32"
									class="campoPersonalizado" style="color: #023449; font-weight: 700;" />
							</v-col> -->
							<v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="6">
								<label style="color: white;" class="font-weight-bold">Produção estimada de
									energia anual</label>
								<v-text-field v-model="dadosCalculo.prodEnergiaEst" readonly outlined dense type="text"
									background-color="#B1E8F7" color="#023449" class="campoPersonalizado"
									style="color: #023449; font-weight: 700;" />
							</v-col>
							<v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="6">
								<label style="color: white;" class="font-weight-bold">Economia estimada anual</label>
								<v-text-field color="#023449" v-model="dadosCalculo.economiaEst" readonly outlined dense
									type="text" background-color="#B1E8F7" class="campoPersonalizado"
									style="color: #023449; font-weight: 700;" />
							</v-col>
						</v-row>
					</v-fade-transition>

					<!-- Linha 6 -->
					<!-- <v-fade-transition mode="out-in">
						<v-row v-show="resultadosVisiveis"> -->
					<!-- <v-col class="mb-n6 px-1 pa-1" cols="12" sm="12" md="12">
								<label style="color: white;" class="font-weight-bold">Área ocupada pelo sistema no
									telhado</label>
								<v-text-field v-model="dadosCalculo.areaTelhado" readonly outlined dense type="text"
									suffix="m²" background-color="#2E7D32" class="campoPersonalizado"
									style="color: #023449; font-weight: 700;" />
							</v-col> -->
					<!-- CALCULO DE SELECIONAR CATEGORIA DE PAINEL E DETERMINAR QTD DE PAINEIS-->
					<!-- <v-col class="mb-n6 px-1 pt-1 pb-6" cols="12" sm="12" md="12">
								<v-card color="#5B93AB" light class="pa-2">
									<v-row>
										<v-col>
											<label style="color: primary;"
												class="font-weight-bold white--text">Categoria de Painel
												Solar</label>
											<v-select :items="categorias" outlined dense :disabled="carregando"
												item-text="categoria" item-value="area" filled @change="calculaPaineis"
												v-model="tamanhoPainel" background-color="#2E7D32" class="mb-n6 px-1">
											</v-select>
										</v-col>
									</v-row>

									<v-fade-transition mode="out-in">
										<v-row v-show="mostraQTDPaineis">
											<v-col cols="12" class="pt-0">
												<label style="color: primary;" class="font-weight-bold white--text">QTD
													de Paineis
													necessários:</label>
												<v-text-field v-model="qtdPaineis" readonly outlined dense type="text"
													background-color="#2E7D32" class="campoPersonalizado mb-n6 px-1"
													style="color: #023449; font-weight: 700;" />

											</v-col>
											<v-col cols="12">
												<h2 class="px-1" style="color: white;">Tamanho do painel (área): {{
													(tamanhoPainel || 0).toFixed(2) }} m²</h2>
												<h2 class="px-1" style="color: white;">Dimensões base da categoria: {{
													categorias?.find(c => c?.area === tamanhoPainel)?.dimensoes}}</h2>
											</v-col>
										</v-row>
									</v-fade-transition>


								</v-card>
							</v-col> -->
					<!-- </v-row>
					</v-fade-transition> -->



					<v-row>
						<v-col cols="12" class="pa-2">
							<v-btn block dark color="#2E7D32" @click="buscaProdutos(); produtosVisiveis = true;"
								:disabled="(!this.dadosCalculo.consumoMedio
									&& !this.dadosCalculo.valorkWCidade) || this.dadosCalculo.tamGerador === 0 || this.dadosCalculo.consumoMedio >= 2000">
								Ver produtos compatíveis
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
			<!-- <v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody" /> -->
			<v-fade-transition origin>
				<v-card v-show="produtosVisiveis" shaped light style="background-color: #6BADC9;" elevation="0">
					<v-card-title class="flex-wrap gap-2">
						<span class="text-h6 text-md-h5 font-weight-bold primary--text">
							Sugestão de produtos compatíveis
						</span>
					</v-card-title>


					<!-- <v-divider /> -->

					<v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody" class="ma-4" />

					<v-card-text v-else>
						<v-row dense>
							<v-col v-for="(produto, index) in dados.lista" :key="index" cols="12" sm="6" md="4" lg="3">
								<v-card class="h-100 d-flex flex-column" color="white">
									<!-- <v-sheet class="d-flex align-center justify-center" color="#1C71A1" height="150">
										<span class="text-grey-darken-2">Sem imagem</span>
									</v-sheet> -->
									<v-img :src="produto.imagem" height="300" contain></v-img>

									<v-divider />

									<v-card-title class="text-wrap subtitle-1 font-weight-bold white--text"
										style="background-color: #023449;">
										{{ produto.id + ' - ' + produto.produto }}
									</v-card-title>

									<v-card-subtitle class="descricao text-body-2" light
										style="background-color: #023449;">
										<p style="color: #A5C1D4;"> <strong>Descrição:</strong> {{ produto.descricao }}
										</p>
									</v-card-subtitle>

									<v-card-text light style="background-color: #023449;">
										<div class="font-weight-bold white--text" v-if="produto.potencia > 0">
											<p class="ma-0" style="color: #C62828;">Potência Kit: {{ produto.potencia
											}}kWp</p>
											<p class="ma-0">QTD Média de Painéis: {{ calculoProduto(produto, 'Q') }}</p>
											<p class="ma-0" style="color: #43A047;">Preço médio: {{
												calculoProduto(produto, 'P') | formataDinheiro }}
											</p>
										</div>
										<div class="font-weight-bold white--text" v-else>
											<p style="color: #C62828;">Potência: {{ produto.watts }}W</p><br />
											<p>QTD Média de Painéis: {{ calculoProduto(produto, 'Q') }}</p><br />
											<p>Preço médio: {{ calculoProduto(produto, 'P') | formataDinheiro }}W</p>
											<br />
										</div>
									</v-card-text>

									<v-spacer />

									<v-divider />

									<v-card-actions style="background-color: #023449;">
										<v-btn color="white" variant="flat" block
											@click="listaInformacaoProduto(produto)">
											Ver mais
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-col>

						</v-row>
						<v-row>
							<v-col class="pa-0">
								<!-- <v-divider /> -->

							</v-col>
						</v-row>
						<v-pagination v-model="pgSelecionadaLocal" :length="Math.ceil(dados.total / pgLimit)"
							:total-visible="pgLimit" :disabled="carregando2" class="ma-2" @input="onMudarPagina" />

					</v-card-text>


				</v-card>
			</v-fade-transition>




		</v-card-text>
		<v-progress-linear indeterminate absolute :active="carregando" />
	</v-card>
</template>


<script>
import axios from "axios";
import { mapState } from "vuex";
import CardDialog from "../Widgets/CardDialog";
// import Paginacao from "../Widgets/Paginacao";
import mixinFilial from "../../util/mixinFilial";

export default {
	name: "CalculadoraSolar",
	components: { CardDialog },
	mixins: [mixinFilial],
	data: () => ({
		step: 1,
		sheet: false,
		carregando: false,
		carregando2: false,
		carregando3: false,
		carregandoSkeleton: true,
    snackbar: { status: false, timeout: 10000, text: 'Consumos acima de 2.000 kWh requerem avaliação técnica especializada. Entre em contato com o engenheiro solar para garantir o dimensionamento adequado do sistema.' , color: 'red'},
		dados: { lista: [], total: 0 },
		cadastro: {},
		dialogErro: {
			status: false,
			title: "",
			msg: "",
			icon: "",
			iconColor: "",
		},
		pgSelecionada: 0,
		pgSelecionadaLocal: 1,
		pgLimit2: 20,
		dadosCalculo: {
			uf: 0,
			cidade: '',
			cidadeString: '',
			consumoMedio: 0,
			valorkWCidade: 0,
			tipoTelhado: 0,
			cobertura: 0,
			tamGerador: 0,
			incidenciaSolar: 0,
			areaTelhado: 0,
			prodEnergiaEst: 0,
			economiaEst: 0,
			sustentabilidade: 0,
			qtdPlacas: 0,
			valorEstimadoKit: 0,
		},
		dadosLog:
		{
			cidade: '',
			uf: '',
		}
		,
		estados: [],
		cidades: [],
		cidades2: [],
		telhados: [],
		paineis: [],
		categorias: [],
		geradores: [],
		tamanhoPainel: 0,
		areaPainel: 0,
		qtdPaineis: 0,
		dimensoes: '',
		mostraQTDPaineis: false,
		resultadosVisiveis: false,
		produtosVisiveis: false,
		produtoDialog: false,
		dadosDialog: [],
		aguardarBusca: null,
		aguardarBuscaCidade: null,
		search: null,
		searchCidade: null,
		clientes: [],
		clienteSelecionado: {
			idclifor: null,
			uf: null,
			cidade: null,
		},
	}),
	computed: {
		...mapState(["backendUrl", "pgLimit", "timeLimit", "usuario"]),
		filiaisFiltro() {
			if (this.filiais.lista) {
				return this.filiais.lista.filter((v) => {
					return (
						v.idfilial != 6 &&
						v.idfilial != 12 &&
						v.idfilial != 25 &&
						v.idfilial != 29 &&
						v.idfilial != 33 &&
						v.idfilial != 37
					);
				});
			} else {
				return [];
			}
		},
		// cidadesFiltradas() {
		// 	if (!this.dadosCalculo.uf) return []
		// 	return this.cidades.filter(c => c.iduf === this.dadosCalculo.uf)
		// },
		items() {
			if (this.clientes == null) return;

			this.clientes.forEach((cliente) => {
				if (cliente.nome.length > this.nomeLimit) {
					cliente.nome =
						cliente.nome.slice(0, this.nomeLimit) + "...";
				}
			});

			return this.clientes;
		},
		itemsCidades() {
			if (this.cidades == null) return;
			this.cidades.forEach((cidade1) => {
				if (cidade1.cidade.length > this.nomeLimit) {
					cidade1.cidade =
						cidade1.cidade.slice(0, this.nomeLimit) + "...";
				}
			});
			return this.cidades;
		},

	},
	watch: {
		// "dadosCalculo.uf"(novoValor) {
		// 	if (novoValor) {
		// 		this.dadosCalculo.cidade = null
		// 	}
		// },
		"dadosCalculo.cidade"(novoValor) {
			if (novoValor === null) {
				this.dadosCalculo.incidenciaSolar = 0
			}

			let cidadeSelecionada = this.cidades.find(c => c.id === novoValor)
			console.log('Cidade: ', cidadeSelecionada)
			this.dadosCalculo.incidenciaSolar = cidadeSelecionada ? cidadeSelecionada.incidencia_solar : 0
			this.dadosLog.cidade = cidadeSelecionada ? cidadeSelecionada.cidade : ""
			console.log('Cidade LOG: ', this.dadosLog.cidade)
		},
		"clienteSelecionado.idclifor"(novoValor) {

			console.log("Novo Cliente Selecionado:", novoValor); // Verifica o ID do cliente selecionado
			console.log("Lista de Clientes Disponível:", this.clientes); // Confirma os dados carregados
			if (novoValor === null) {
				return
			}

			const clienteSelecionado = this.clientes.find(c => c.idcliente === novoValor);

			console.log("Cliente Encontrado:", clienteSelecionado); // Confirma se o cliente foi encontrado
			this.dadosLog.cidade = clienteSelecionado.endereco.cidade;
			console.log('Cidade log', this.dadosLog.cidade)

			const UFCliente = this.estados.find(e => e.uf === clienteSelecionado.endereco.uf)
			const CidadeCliente = this.cidades.filter(c => c.id === clienteSelecionado.idcidadeibge)

			//console.log(CidadeCliente)
			//console.log(clienteSelecionado)

			this.dadosCalculo.uf = UFCliente ? UFCliente.id : null;
			this.dadosCalculo.cidade = CidadeCliente ? CidadeCliente[0].id : null;
			this.dadosLog.cidade = CidadeCliente ? CidadeCliente[0].endereco.cidade : null;
			this.dadosLog.uf = CidadeCliente ? CidadeCliente[0].endereco.uf : null;

			//console.log('Dados Log: ', this.dadosLog.cidade)
		},
		search: function (val) {
			this.carregarClientes(val);
		},
		searchCidade: function (val) {
			this.carregarCidades(val);
		},
	},
	methods: {
		calculos() {
			/// Cálculos definidos com Rômulo - Engenheiro Solar

			// QTD de Paineis
			this.dadosCalculo.qtdPlacas = (this.dadosCalculo.consumoMedio / 55).toFixed(0) // 55W potência presumida que cada painel produz em média para cálculo

			// Potência Gerador
			this.dadosCalculo.tamGerador = (this.dadosCalculo.qtdPlacas * 0.61).toFixed(2) // 610W potência do gerador

			const consumoInserido = this.dadosCalculo.consumoMedio
			console.log('consumo: ', consumoInserido)
			// Valor Médio Kit
			if (consumoInserido > 0 && consumoInserido <= 399) {
				this.dadosCalculo.valorEstimadoKit = 'R$ ' +
					(this.dadosCalculo.tamGerador * 3148.50).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			}
			else if (consumoInserido >= 400 && consumoInserido <= 699) {
				this.dadosCalculo.valorEstimadoKit = 'R$ ' +
					(this.dadosCalculo.tamGerador * 2435.33).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			} else if (consumoInserido >= 700 && consumoInserido <= 899) {
				this.dadosCalculo.valorEstimadoKit = 'R$ ' +
					(this.dadosCalculo.tamGerador * 2075.75).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			} else if (consumoInserido >= 900 && consumoInserido <= 1299) {
				this.dadosCalculo.valorEstimadoKit = 'R$ ' +
					(this.dadosCalculo.tamGerador * 2238.96).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			} else if (consumoInserido >= 1300 && consumoInserido <= 4300) {
				this.dadosCalculo.valorEstimadoKit = 'R$ ' +
					(this.dadosCalculo.tamGerador * 2016.88).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			} else {
				this.dadosCalculo.valorEstimadoKit = 'R$ ' +
					(this.dadosCalculo.tamGerador * 2016.88).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
			}

			///

			//// Cálculos do site antigo
			// tamanho gerador
			// if (this.dadosCalculo.consumoMedio > 0) {
			// 	this.dadosCalculo.tamGerador = ((this.dadosCalculo.consumoMedio / 30) / this.dadosCalculo.incidenciaSolar).toFixed(2)
			// } else {
			// 	this.dadosCalculo.tamGerador = 0
			// }


			//produção de energia estimada
			this.dadosCalculo.prodEnergiaEst = (this.dadosCalculo.tamGerador * (30 * (this.dadosCalculo.incidenciaSolar * 12))).toFixed(2)

			// Area ocupada do telhado
			this.dadosCalculo.areaTelhado = (this.dadosCalculo.tamGerador * ((1000 / 330) * 2.3)).toFixed(2)

			// calculo de sustentabilidade
			this.dadosCalculo.sustentabilidade = (this.dadosCalculo.tamGerador * 408).toFixed(2)

			// calculo de economia estimada
			if (this.dadosCalculo.prodEnergiaEst !== 0 && this.dadosCalculo.valorkWCidade !== 0) {
				this.dadosCalculo.economiaEst = 'R$ ' + ((this.dadosCalculo.prodEnergiaEst * this.dadosCalculo.valorkWCidade).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))

				// formatar valor de potencia estimada
				this.dadosCalculo.prodEnergiaEst = (this.dadosCalculo.tamGerador * (30 * (this.dadosCalculo.incidenciaSolar * 12))).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

			} else {
				this.dadosCalculo.economiaEst = 0
			}

      if(this.dadosCalculo.consumoMedio >= 2000){
        this.snackbar.status = true;
      }

			this.registraLog();

		},
		calculaPaineis() {
			console.log('Area selecionada: ', this.tamanhoPainel)

			this.qtdPaineis = (this.dadosCalculo.areaTelhado / this.tamanhoPainel).toFixed(0)
			this.mostraQTDPaineis = true;
		},
		calculoProduto(produto, tipoCalculo) {

			const qtdPainel = ((produto.potencia / (produto.watts / 1000)) || 0).toFixed(0)
			const consumo = qtdPainel * 55

			if (tipoCalculo === 'P') {
				// Valor Médio Kit
				if (consumo > 0 && consumo <= 399) {
					return produto.potencia * 3148.50
				}
				else if (consumo >= 400 && consumo <= 699) {
					return produto.potencia * 2435.33
				} else if (consumo >= 700 && consumo <= 899) {
					return produto.potencia * 2075.75
				} else if (consumo >= 900 && consumo <= 1299) {
					return produto.potencia * 2238.96
				} else if (consumo >= 1300 && consumo <= 4300) {
					return produto.potencia * 2016.88
				} else {
					return produto.potencia * 2016.88
				}
			} else {
				return qtdPainel
			}
		},
		// teste(){
		// 	this.dimensoes = categorias.find(c => c.area === tamanhoPainel).dimensoes
		// },
		listarUFs() {
			return axios
				.post(`${this.backendUrl}solar/estados/listar`, {})
				.then((res) => {

					this.estados = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		listarCidades() {
			return axios
				.post(`${this.backendUrl}solar/cidades/listar`, {})
				.then((res) => {

					this.cidades = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		listarTelhados() {
			return axios
				.post(`${this.backendUrl}solar/telhados/listar`, {})
				.then((res) => {

					this.telhados = res.data;
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		listaPaineis() {
			return axios
				.post(`${this.backendUrl}solar/paineis/listar`, {})
				.then((res) => {
					this.paineis = res.data;


					// pega o maior painel de cada categoria
					this.categorias = Object.values(
						this.paineis.reduce((acc, painel) => {
							const cat = painel.categoria;
							if (!acc[cat] || painel.area > acc[cat].area) {
								acc[cat] = painel;
							}
							return acc;
						}, {})
					);

					console.log(this.categorias)
					this.carregando = false;
				})
				.catch(() => {
					this.carregando = false;
				});
		},
		onMudarPagina(paginaUI) {
			this.pgSelecionada = paginaUI - 1;
			this.buscaProdutos();
		},
		buscaProdutos() {
			this.dados.lista = [];
			this.dados.total = 0;
			console.log('Pagina selecionada: ', this.pgSelecionada)
			this.carregando2 = true
			this.carregandoSkeleton = true
			return axios
				.post(`${this.backendUrl}solar/produtos/listar`, {
					potencia_kwp: parseFloat(this.dadosCalculo.tamGerador) || 0,
					tipo_telhado: this.dadosCalculo.tipoTelhado || 0,
					limit: this.pgLimit,
					offset: this.pgLimit * this.pgSelecionada,
				})
				.then((res) => {

					this.dados.lista = res.data.lista;
					this.dados.total = res.data.total;

					this.geradores = this.dados.lista.filter(item => parseFloat(item.potencia) > 0)
					this.carregando2 = false;
					this.carregandoSkeleton = false;
				})
				.catch(() => {
					this.carregando2 = false;
					this.carregandoSkeleton = false;
				});

		},
		registraLog() {
			if (this.dadosCalculo.cidade && this.dadosCalculo.tamGerador && this.dadosCalculo.valorkWCidade) {
				console.log(this.dadosCalculo.economiaEst)
				console.log(this.dadosCalculo.valorEstimadoKit)
				return axios
					.post(`${this.backendUrl}solar/log`, {
						iduf: this.dadosLog.uf || 0,
						cidade: this.dadosLog.cidade,
						consumo_medio: (this.dadosCalculo.consumoMedio),
						valor_kwh: parseFloat(this.dadosCalculo.valorkWCidade),
						tipo_telhado: this.dadosCalculo.tipoTelhado || 0,
						tamanho_gerador: parseFloat(this.dadosCalculo.tamGerador),
						incidencia: parseFloat(this.dadosCalculo.incidenciaSolar),
						area_telhado: parseFloat(this.dadosCalculo.areaTelhado),
						producao_estimada: parseFloat(this.dadosCalculo.prodEnergiaEst),
						sustentabilidade: parseFloat(this.dadosCalculo.sustentabilidade),
						economia_estimada: this.dadosCalculo.economiaEst,
						idfilial: 0,
						idusuario: 0,
						idclifor: this.clienteSelecionado.idclifor || 0,
						qtdplaca: parseInt(this.dadosCalculo.qtdPlacas),
						valorcalckit: this.dadosCalculo.valorEstimadoKit

					})
					.then(() => {
					})
					.catch(() => {
					});
			} else {
				return
			}
		},
		carregarClientes(val) {
			clearTimeout(this.aguardarBusca);
			this.aguardarBusca = setTimeout(() => {
				this.carregando2 = true;
				return axios
					.post(`${this.backendUrl}cliente/listar`, {
						limit: 30,
						offset: 0,
						busca: val || null,
					})
					.then((res) => {
						this.clientes = res.data.lista.map((v) => {
							return {
								...v,
								idenome: `${v.idcliente} - ${v.nome}`,
								telefone: `${v.telefoneComercial}`
							};
						});
						this.carregando2 = false;
					})
					.catch(() => {
						this.carregando2 = false;
					});
			}, this.timeLimit);
		},
		// carregarCidades(val) {
		// 	clearTimeout(this.aguardarBuscaCidade);
		// 	this.aguardarBuscaCidade = setTimeout(() => {
		// 		this.carregando3 = true;

		// 		try {
		// 			const filtro = val
		// 			const cidadesFiltradas = this.cidades 
		// 				.filter(v =>
		// 					v.id.includes(filtro)
		// 				)
		// 				.map(v => ({
		// 					...v,
		// 					selectCidade: `${v.cidade}`,
		// 				}));

		// 			this.cidades = cidadesFiltradas;
		// 		} catch (e) {
		// 			console.error("Erro ao carregar cidades:", e);
		// 		} finally {
		// 			this.carregando3 = false;
		// 		}
		// 	}, this.timeLimit);
		// },

		listaInformacaoProduto(produto) {
			this.produtoDialog = true;
			this.dadosDialog = produto;
		},
		limpar() {
			this.clienteSelecionado.idclifor = null;
			this.clienteSelecionado.uf = '';
			this.dadosCalculo.areaTelhado = 0;
			this.dadosCalculo.sustentabilidade = 0;
			this.dadosCalculo.tamGerador = 0;
			this.dadosCalculo.consumoMedio = 0;
			this.dadosCalculo.valorkWCidade = 0;
			this.dadosCalculo.prodEnergiaEst = 0;
			this.dadosCalculo.economiaEst = 0;
			this.dadosCalculo.cobertura = 0;
			this.dadosCalculo.uf = null;
			this.dadosCalculo.cidade = null;
			this.dadosCalculo.tipoTelhado = null;
			this.produtosVisiveis = false;
			this.resultadosVisiveis = false;
			this.dados.lista = [];
			this.dados.total = 0;
		},
		refreshNovoDado(tipo) {
			if (tipo === 'CM' && this.dadosCalculo.tamGerador > 0) {
				this.dadosCalculo.tamGerador = 0;
				this.clienteSelecionado.idclifor = null;
				this.dadosCalculo.cidade = null;
				this.dadosCalculo.valorkWCidade = 0;
				this.resultadosVisiveis = false;
			} else if (tipo === 'CL' && this.dadosCalculo.tamGerador > 0) {
				this.dadosCalculo.tamGerador = 0;
				this.dadosCalculo.cidade = null;
				this.dadosCalculo.consumoMedio = 0;
				this.dadosCalculo.valorkWCidade = 0;
			} else if (tipo === 'C' && this.dadosCalculo.tamGerador > 0) {
				this.dadosCalculo.tamGerador = 0;
				this.clienteSelecionado.idclifor = null;
				this.dadosCalculo.consumoMedio = 0;
				this.dadosCalculo.valorkWCidade = 0;
				this.resultadosVisiveis = false;
			} else if (tipo === 'V' && this.dadosCalculo.tamGerador > 0) {
				this.dadosCalculo.tamGerador = 0;
				this.clienteSelecionado.idclifor = null;
				this.dadosCalculo.consumoMedio = 0;
				this.dadosCalculo.cidade = null;
				this.resultadosVisiveis = false;
			}
		},
		async init() {
			this.limpar();
			this.listarUFs();
			this.listarCidades();
			this.listarTelhados();
			this.listaPaineis();
			this.buscaProdutos(0);
		},
	},
	created() {
		this.init();
	},
	mounted() {
		this.carregarClientes();
	}
};
</script>

<style>
.descricao {
	max-height: 60px;
	/* limite de altura */
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	/* número máximo de linhas */
	-webkit-box-orient: vertical;
}

.campoPersonalizado input {
	color: #023449 !important;
	font-weight: 700;
}

@media (max-width: 550px) {
	.mt-mobile-0 {
		margin-top: 0 !important;
	}
}

@media (max-width: 550px) {
	.mb-mobile-0 {
		margin-right: 0 !important;
	}
}
</style>